<div class="subscriptions-page-container">
    <app-subscriptions
        *ngIf="showSubscriptions"
        [userId]="userId"
        [activeOrganization]="activeOrganization"
    ></app-subscriptions>
    <div *ngIf="!showSubscriptions" class="placeholder-message-wrapper">
        <p>{{ placeholderMessageKey | translate }}</p>
    </div>
</div>
